<script lang="ts">
	import type { MenuItem } from "../../../../core/schema/MenuItem.js";
	import type { Writable } from "svelte/store";
	import { createEventDispatcher } from "svelte";
	import Link from "../Link.svelte";
	import arrowDown from "../../../../core/assets/icons/arrow-down.svg?raw";
	import Icon from "../Icon.svelte";

	export let menuItem: MenuItem;
	export let activeSubmenu: Writable<MenuItem["id"] | null>;

	const dispatch = createEventDispatcher<{ click: MenuItem }>();

	let openCategories: Record<string, boolean> = {};

	function toggleCategory(name: string): void {
		openCategories = { ...openCategories, [name]: !openCategories[name] };
	}

	function isSubmenuActive(submenu: MenuItem["id"] | null, item: MenuItem): boolean {
		if (item.id === submenu) {
			return true;
		}
		return (
			item.submenus?.some(
				(subItem) => subItem.items?.some((nestedItem) => isSubmenuActive(submenu, nestedItem)) ?? false,
			) ?? false
		);
	}

	function handleItemClick(item: MenuItem): () => void {
		return (): void => {
			dispatch("click", item);
		};
	}

	$: submenus = menuItem.submenus ?? [];
</script>

{#if submenus.length > 0}
	<!-- Mobile -->
	<div
		class="grid grid-rows-[0fr] transition-[grid-template-rows] duration-300 ease-in-out xl:hidden
		{isSubmenuActive($activeSubmenu, menuItem) ? 'grid-rows-[1fr]' : ''}"
	>
		<div class="w-full overflow-hidden px-6">
			{#each submenus as submenuItem}
				{#if submenuItem.name}
					<div class="flex w-full flex-col">
						<button
							type="button"
							on:click={() => {
								toggleCategory(submenuItem.name);
							}}
							class="text-ltprimary flex w-full items-center justify-between gap-3 py-3 text-left text-xs !font-medium uppercase tracking-[0.1rem]"
						>
							{#if submenuItem.path}
								<a href="/{submenuItem.path}" class="flex-1">{submenuItem.name}</a>
							{:else}
								<span class="flex-1">{submenuItem.name}</span>
							{/if}
							<Icon
								icon={arrowDown}
								class="w-5 shrink-0 transition-transform duration-300 {openCategories[submenuItem.name]
									? 'rotate-180'
									: ''}"
							/>
						</button>
						<div
							class="grid grid-rows-[0fr] transition-[grid-template-rows] duration-300 ease-in-out
							{openCategories[submenuItem.name] ? 'grid-rows-[1fr]' : ''}"
						>
							<div class="overflow-hidden">
								{#each submenuItem.items ?? [] as item}
									<div class="flex w-full">
										<Link
											noUnderline
											class="!text-ltsecondary block w-full py-2.5 pl-4 text-sm !font-light"
											iconGap="mr-0"
											href="/{item.path}{item.anchor ? `#${item.anchor}` : ''}"
											target={item.target}
											on:click={handleItemClick(item)}
										>
											{item.name}
										</Link>
									</div>
								{/each}
							</div>
						</div>
					</div>
				{:else}
					{#each submenuItem.items ?? [] as item}
						<div class="flex w-full">
							<Link
								noUnderline
								class="!text-ltsecondary block w-full py-2.5 text-sm !font-light"
								iconGap="mr-0"
								href="/{item.path}{item.anchor ? `#${item.anchor}` : ''}"
								target={item.target}
								on:click={handleItemClick(item)}
							>
								{item.name}
							</Link>
						</div>
					{/each}
				{/if}
			{/each}
		</div>
	</div>
{/if}
